import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import FeatureCard from "../../common/feature-card/FeatureCard";
import useLangNavigate from "../../common/useLangNavigate";
import iWantToWriteNew from "../../../assets/png/i-want-to-write-new.png";
import writingIcon from "../../../assets/png/i-already-started.png";

const WritingModeChoice = () => {
  const { t } = useTranslation();
  const navigate = useLangNavigate();
  const { service_id, flow_type } = useParams();

  const options = [
    {
      key: "ai",
      name: t("writing_mode.ai_assisted"),
      description: t("writing_mode.ai_assisted_desc"),
      icon: iWantToWriteNew,
      action: () =>
        navigate(
          `/general-categories/${service_id}/${flow_type}?write_mode=ai`,
        ),
    },
    {
      key: "self",
      name: t("writing_mode.self_write"),
      description: t("writing_mode.self_write_desc"),
      icon: writingIcon,
      action: () =>
        navigate(
          `/general-categories/${service_id}/${flow_type}?write_mode=self`,
        ),
    },
  ];

  return (
    <section className="aai-features py-100 landing-page-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-10">
            <div className="aai-section-title mb-5 text-center">
              <h2 className="section-title">{t("writing_mode.main_title")}</h2>
              <p className="section-desc">{t("writing_mode.main_subtitle")}</p>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {options.map((item) => (
            <FeatureCard
              key={`writing-mode-${item.key}`}
              onClick={item.action}
              img={item.icon}
              name={item.name}
              description={item.description}
              showArrow={true}
              variant="landing"
              colClasses="col-lg-5 col-md-6"
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WritingModeChoice;
